import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./ProjectLanguages.css";

const ProjectLanguages = (props) => {
  const logos = props.logos;
  return (
    <div>
      <div className="skills-main-div">
        <ul className="dev-icons-languages">
          {logos.map((logo) => {
            return (
              <OverlayTrigger
                key={logo.name}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-top`}>
                    <strong>{logo.name}</strong>
                  </Tooltip>
                }
              >
                <li
                  className="software-skill-inline-languages"
                  name={logo.skillName}
                >
                  <span
                    className="iconify"
                    data-icon={logo.iconifyClass}
                    data-inline="false"
                  ></span>
                </li>
              </OverlayTrigger>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ProjectLanguages;
